import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { CpfField } from '../../components/Fields'
import { connect } from 'react-redux'
import { userActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import InputAdornment from '@material-ui/core/InputAdornment'
import jwt_decode from 'jwt-decode'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '340px'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  capsLockWarning: {
    position: 'absolute',
    bottom: '-25px',
    margin: 0,
    color: '#212121',
    fontSize: '13px'
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class UpdatePassword extends Component {
  state = {
    showOldPassword: false,
    showNewPassword: false,
    showCapsLockMessage: false
  }
  componentDidUpdate(newProps) {
    if (newProps.open !== this.props.open && !!newProps.open === true) {
      this.setState({
        showOldPassword: false,
        showNewPassword: false,
        showCapsLockMessage: false
      })
    }
  }
  componentDidMount() {
    document.onkeyup = this.toggleCapsLockMessage
    document.onkeydown = this.toggleCapsLockMessage
  }

  componentWillUnmount() {
    document.onkeyup = undefined
    document.onkeydown = undefined
  }
  toggleShowOldPassword = () => {
    this.setState(state => {
      return { showOldPassword: !state.showOldPassword }
    })
  }
  toggleShowNewPassword = () => {
    this.setState(state => {
      return { showNewPassword: !state.showNewPassword }
    })
  }
  handleSubmit = (e, params) => {
    e.preventDefault()
    const { token, changeMessage, onClose } = this.props
    const { user } = jwt_decode(token)
    this.props
      .updatePassword({ params: params, id: user._id })
      .then(response => {
        onClose()
        changeMessage({ message: 'Senha definida com sucesso.' })
      })
      .catch(err => {
        if (err.response.status === 401) {
          changeMessage({ message: 'Senha atual incorreta.' })
        }

        if (err.response.status === 400) {
          changeMessage({ message: 'Por favor, preencha todos os campos.' })
        }
      })
  }
  clearErrors = () => {
    this.setState({ formErrors: {} })
  }
  toggleCapsLockMessage = e => {
    this.setState({
      showCapsLockMessage: e.getModifierState && e.getModifierState('CapsLock')
    })
  }
  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      user,
      updatePasswordForm,
      loadingUser,
      changeUpdatePasswordForm
    } = this.props
    const { handleSubmit, clearErrors } = this
    const { oldPassword, newPassword } = updatePasswordForm
    return (
      <div>
        <Dialog
          modalId="usuarios-alterar-senha"
          modalParams={{ registro: (user || {})._id }}
          fullScreen={fullScreen}
          open={open}
          onClose={onClose}
        >
          {loadingUser ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id="usuarios-alterar-senha-title">
                Usuários — Alterar senha
              </DialogTitle>
              <DialogContent>
                <form
                  id={'user-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, updatePasswordForm)
                  }}
                >
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="field-password-login">Senha atual</InputLabel>
                    <Input
                      value={oldPassword}
                      onChange={e => {
                        changeUpdatePasswordForm({ newPassword, oldPassword: e.target.value })
                      }}
                      fullWidth
                      autoFocus
                      type={this.state.showOldPassword ? 'text' : 'password'}
                      id="field-old-pass"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.toggleShowOldPassword}
                            onMouseDown={e => {
                              e.preventDefault()
                            }}
                          >
                            {this.state.showOldPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>

                  <FormControl fullWidth className={classes.formControlPassword}>
                    <InputLabel htmlFor="field-password-login">Senha nova</InputLabel>
                    <Input
                      value={newPassword}
                      fullWidth
                      type={this.state.showNewPassword ? 'text' : 'password'}
                      onChange={e => {
                        changeUpdatePasswordForm({ oldPassword, newPassword: e.target.value })
                      }}
                      id="field-new-pass"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.toggleShowNewPassword}
                            onMouseDown={e => {
                              e.preventDefault()
                            }}
                          >
                            {this.state.showNewPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    {this.state.showCapsLockMessage ? (
                      <Typography className={classes.capsLockWarning}>
                        Atenção: <strong>CAPS Lock</strong> está ligado
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  Cancelar
                </Button>
                <Button type={'submit'} form={'user-form'} color="primary" variant="raised">
                  Salvar
                </Button>
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

UpdatePassword.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    updatePasswordForm: state.user.updatePasswordForm,
    loadingUser: state.user.loadingUser,
    userFormErrors: state.user.userFormErrors,
    formTouched: state.user.userFormTouched,
    profiles: state.user.profiles,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(userActions.openModal())
    },
    closeModal: () => {
      dispatch(userActions.closeModal())
    },
    handleChangeUser: user => {
      dispatch(userActions.handleChangeUser(user))
    },
    addUser: user => {
      return dispatch(userActions.addUser(user))
    },
    updatePassword: updatePasswordForm => {
      return dispatch(userActions.updatePassword(updatePasswordForm))
    },
    editUser: user => {
      return dispatch(userActions.editUser(user))
    },
    setUserFormTouched: user => {
      dispatch(userActions.setUserFormTouched())
    },
    changeUpdatePasswordForm: updatePasswordForm => {
      dispatch(userActions.changeUpdatePasswordForm(updatePasswordForm))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchProfiles: () => {
      dispatch(userActions.fetchProfiles())
    },
    fetchUsers: ({ page, perPage }) => {
      dispatch(userActions.fetchUsers({ page, perPage }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(UpdatePassword)))



// WEBPACK FOOTER //
// ./src/containers/Users/UpdatePassword.js